/* eslint-disable max-len */
import React, { useEffect, useState } from 'react';
import { Disclosure } from '@headlessui/react';
import { useSelector } from 'react-redux';
import ToolTip from '../../../CommonComponent/tooltip';
import config from '../../../config';
import { dataService } from '../../../services/dataService';

const NON_DRAFT_STATUSES = ['Published', 'Accepting Bids', 'Accepting bids', 'In Progress', 'Completed', 'Cancelled'];

export default function CustomUrlSection({ auctionData, vanitySlug }) {
    const planTypeFromStore = useSelector((state) => state.pricingSlice.plan_type);
    const planType = planTypeFromStore || localStorage.getItem('plan_type');
    const [sellerSubdomain, setSellerSubdomain] = useState('');

    useEffect(() => {
        const fetchSubdomain = async () => {
            const response = await dataService.SubDomainSetup('?view=True', {});
            if (response?.error === false) {
                setSellerSubdomain(response.data?.subdomain || '');
            }
        };
        fetchSubdomain();
    }, []);

    if (planType !== 'Pro' || !vanitySlug) {
        return null;
    }

    const isLocked = NON_DRAFT_STATUSES.includes(auctionData.status);
    const host = `${sellerSubdomain || 'bid'}.${config.Environment.domain}`;
    const showCustomSlugInPreview = Boolean(vanitySlug.slug) && !vanitySlug.isFormatInvalid && !vanitySlug.isTaken;
    const previewPath = showCustomSlugInPreview ? vanitySlug.slug : `auctions/${auctionData._id || 'auction-id'}`;
    const previewUrl = `${host}/${previewPath}`;

    return (
        <Disclosure as="div" className="px-9 pt-4 border-b pb-[24px]" defaultOpen={true}>
            {({ open }) => (
                <>
                    <Disclosure.Button className="flex justify-between w-full items-center">
                        <span className="flex items-center gap-2">
                            <p className="font-medium text-[#343434] text-[14px] leading-normal">Custom URL</p>
                            <ToolTip trigger="mouseenter"
                                content="The URL preview shows what your auction URL will be. Edit your URL path below. To customise your sub-domain, please go to your Account Settings.">
                                <img src="/images/info-icon.svg" className="cursor-pointer" alt="info-icon" loading="lazy" />
                            </ToolTip>
                        </span>
                        <img src={open ? "/images/auction-hide-dropdown.svg" : "/images/auction-show-dropdown.svg"} className="cursor-pointer header-dropdown"
                            alt="dropdown-icon" loading="lazy" />
                    </Disclosure.Button>
                    <Disclosure.Panel>
                        <div className='bg-[#FAFAFA] rounded-md p-3 mt-[28px] border border-[#A1A1A9]'>
                            <div>
                                <p className="font-medium text-[#343434] mb-1 text-[12px] leading-normal">URL preview</p>
                                <p className="border border-[#A1A1A9] p-2 bg-[#F4F4F5] rounded text-[12px] font-medium leading-normal text-[#343434] break-all">{previewUrl}</p>
                            </div>
                            {!isLocked && <div className="pt-3">
                                <label htmlFor="vanity_slug" className="font-medium text-[#343434] text-[12px] leading-normal">Edit your URL path </label>
                                <input autoComplete='off' type="text" value={vanitySlug.slug} id='vanity_slug' className={`border w-full p-2 outline-none text-[14px] leading-normal
                            font-medium text-[#343434] placeholder:text-[#A1A1A9] rounded ${vanitySlug.slugError ? 'border-red-500' : vanitySlug.slugSuccess ? 'border-black' : 'border-[#A1A1A9]'}`} placeholder="e.g., benefit-auction" maxLength={50} onChange={(e) => vanitySlug.handleSlugChange(e.target.value)} />
                                {vanitySlug.checkingSlug && <p className="text-[10px] pt-1.5 font-medium leading-normal text-[#A1A1A9]">Checking availability...</p>}
                                {!vanitySlug.checkingSlug && vanitySlug.slugError && (
                                    <p className="flex items-center gap-1 text-[12px] pt-1.5 font-bold leading-normal error-msg text-red-500">
                                        <svg width="8" height="8" viewBox="0 0 8 8" fill="none" className="shrink-0" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                                            <path fillRule="evenodd" clipRule="evenodd" d="M4 3.33333L7.33333 0L8 0.666667L4.66667 4L8 7.33333L7.33333 8L4 4.66667L0.666667 8L0 7.33333L3.33333 4L0 0.666667L0.666667 0L4 3.33333Z" fill="currentColor" />
                                        </svg>
                                        {vanitySlug.slugError}
                                    </p>
                                )}
                                {!vanitySlug.checkingSlug && !vanitySlug.slugError && vanitySlug.slugSuccess && (
                                    <p className="flex items-center gap-1 text-[12px] pt-1.5 font-bold leading-normal text-green-500">
                                        <svg width="9" height="8" viewBox="0 0 9 8" fill="none" className="shrink-0" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                                            <path d="M3 5.96512L0.83 3.83721L0 4.98837L3.08 8L9 1.04651L8.08 0L3 5.96512Z" fill="currentColor" />
                                        </svg>
                                        {vanitySlug.slugSuccess}
                                    </p>
                                )}
                            </div>}
                        </div>
                    </Disclosure.Panel>
                </>
            )}
        </Disclosure>
    );
}
